import { useQuery } from '@tanstack/react-query'
import { bookingService } from '../services'

/**
 * useChannels hook - 获取可用物流渠道
 * @param {Object} params - 可选筛选参数
 * @param {string} params.destinationCountry - 目的国家
 * @param {string} params.shippingMethod - 运输方式 (sea/air)
 */
export function useChannels(params = {}) {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['channels', params.destinationCountry, params.shippingMethod],
    queryFn: () => bookingService.getAvailableChannels(params),
    staleTime: 5 * 60 * 1000, // 5分钟缓存
    retry: 2,
  })

  return {
    channels: data || [],
    isLoading,
    error,
    refetch,
  }
}

export default useChannels
